import React from 'react';
import BannerTitle from './BannerTitle';

const Banner = () => {
    
    return (
        <div className="banner1">
            <img src="https://res.cloudinary.com/encoraaprp/image/upload/c_fill,h_960,w_2050/v1719862426/yc7rxjutgzn4qp9rwred.jpg" alt="strock-text" />

            {/* <video  muted className="bg-vid" width="600" height="300">
        <source src={video} type="video/mp4" />
      </video>      */}

            <div className="bg-overlay"></div>
            <div id="light">
                <div id="lineh1"></div>
                <div className="vertline"></div>
                <div id="lineh2"></div>
                <div id="lineh3"></div>
                <div id="lineh4"></div>
                <div className="vertline2"></div>
                <div id="lineh5"></div>
                <div id="lineh6"></div>
                <div id="lineh7"></div>
                <div id="lineh8"></div>
                <div className="vertline3"></div>
                <div id="lineh9"></div>
                <div id="lineh10"></div>
                <div id="lineh11"></div>
                <div className="vertline4"></div>
                <div id="lineh12"></div>
            </div>
            <BannerTitle />
        </div>
    )
};

export default Banner;